import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import LanguageSwitcher from './LanguageSwitcher';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const links = [
    { path: '/', label: t('nav.home') },
    { path: '/about', label: t('nav.about') },
    { path: '/portfolio', label: t('nav.portfolio'), children: [
      { to: '/portfolio?category=alcoholic', label: t('nav.alcoholic'), testId: 'nav-alcoholic' },
      { to: '/portfolio?category=xitals', label: t('nav.xitals'), testId: 'nav-xitals' },
    ] },
    { path: '/philosophy', label: t('nav.philosophy') },
    { path: '/global', label: t('nav.global') },
    { path: '/contact', label: t('nav.contact') }
  ];

  return (
    <nav className="nav" data-testid="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">ARKORA</Link>
        
        <div className="nav-actions">
          <LanguageSwitcher />
          
          <button 
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            data-testid="theme-toggle"
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          
          <button 
            className="nav-toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          {links.map(link => (
            <li key={link.path} className={link.children ? 'nav-item-dropdown' : undefined}>
              <Link
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
                data-testid={link.children ? 'nav-our-products' : undefined}
              >
                {link.label}
              </Link>
              {link.children && (
                <ul className="nav-dropdown" data-testid="nav-products-dropdown">
                  {link.children.map(child => (
                    <li key={child.to}>
                      <Link to={child.to} className="nav-dropdown-link" onClick={() => setIsOpen(false)} data-testid={child.testId}>
                        {child.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
